import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import WindowsMt5DownloadModal from '../../components/download/WindowsMt5DownloadModal';
import { WINDOWS_MT5_OFFICIAL_DOWNLOAD_LINK } from '../../utils/windowsDownload';

export default function WindowsDownloadRedirect() {
  const { t } = useTranslation();
  const [showChoice, setShowChoice] = useState(true);

  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-10">
      <div className="max-w-xl rounded-3xl bg-white p-8 text-center shadow-xl">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-100 text-amber-600">
          <i className="ri-windows-fill text-3xl" />
        </div>
        <h1 className="mb-3 text-2xl font-bold text-gray-900">{t('windowsDownload.pageTitle')}</h1>
        <p className="text-gray-600">{t('windowsDownload.pageDesc')}</p>
      </div>

      <WindowsMt5DownloadModal
        open={showChoice}
        onClose={() => {
          setShowChoice(false);
          window.location.href = WINDOWS_MT5_OFFICIAL_DOWNLOAD_LINK;
        }}
      />
    </main>
  );
}
